var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInstagram = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF3C09"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.353 10.1956H19.5092C20.7522 10.1956 21.7633 11.2064 21.7635 12.4494V14.8306V19.6061C21.7635 20.8492 20.7525 21.8603 19.5094 21.8603H12.353C11.1099 21.8603 10.0986 20.8492 10.0986 19.6061V14.8308V12.4497C10.0986 11.2066 11.1099 10.1956 12.353 10.1956ZM20.4137 11.5388L20.1558 11.5398L18.4363 11.5454L18.4431 13.5224L20.4137 13.516V11.7955V11.5388ZM14.2662 14.8306C14.6398 14.3137 15.2459 13.9746 15.9311 13.9746C16.6163 13.9746 17.2224 14.3137 17.5955 14.8306C17.8386 15.168 17.9843 15.5807 17.9843 16.0278C17.9843 17.1598 17.0624 18.0807 15.9309 18.0807C14.7986 18.0807 13.8777 17.1598 13.8777 16.0278C13.8779 15.5807 14.0231 15.168 14.2662 14.8306ZM19.5092 20.7235C20.1255 20.7235 20.6269 20.2226 20.6269 19.6059V14.8306H18.8852C19.0356 15.2005 19.1205 15.6045 19.1205 16.0278C19.1205 17.7861 17.6899 19.2176 15.9311 19.2176C14.1721 19.2176 12.7415 17.7861 12.7415 16.0278C12.7415 15.6045 12.8259 15.2005 12.9763 14.8306H11.2351V19.6059C11.2351 20.2226 11.7365 20.7235 12.353 20.7235H19.5092Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram.d9dc68f5.svg";
export { ForwardRef as ReactComponent };